import moment from "moment";
import { Encrption } from "../app-modules/encrption";
import { API_ENDPOINTS } from "./api-endpoints";
import { customAxios } from "./useExPressApi";

const addTask = (toStaffList, fields) => {
  let toStaffIds = toStaffList.value.map((x) => x.id);
  var data = {
    taskDescription: fields.taskDescription,
    dueDate:
      fields?.dueDate === "" ? "" : moment(fields.dueDate).format("YYYY-MM-DD"),
    isHighPriorityTask: fields.isHighPriorityTask,
    staffIds: toStaffIds,
  };
  return customAxios.post(API_ENDPOINTS.INSERT_TASK, data);
};

const getTaskSearch = (pageSize, pageNumber, fields, dateRange, search) => {
  var data = {
    pageSize: pageSize,
    pageNumber: pageNumber,
    taskId: 0,
    staffId: fields.filterByStaffId ? fields.filterByStaffId.id : 0,
    taskDescription: search ? search : "",
    showImportantTasksOnly: fields.isImportant
      ? true
      : fields.isNotImportant
      ? false
      : null,
      dueDateStart: fields.fromUtcDate ? moment(fields.fromUtcDate).format("YYYY-MM-DD") : null,
      dueDateEnd: fields.ToUtcDate ? moment(fields.ToUtcDate).format("YYYY-MM-DD") : null,
    isCompleted: fields.isCompleted
      ? true
      : fields.isNotCompleted
      ? false
      : null,
    isActive: true,
  };

  return customAxios.post(API_ENDPOINTS.GET_ALL_TASKS_BY_SEARCH, data);
};

const getTaskDetail = (id) => {
  return customAxios.get(API_ENDPOINTS.GET_TASK_BY_ID + Encrption(id));
};

const deleteTask = (id) => {
  return customAxios.delete(API_ENDPOINTS.DELETE_TASK + Encrption(id));
};

const deleteTaskDiscussion = (id) => {
  return customAxios.delete(
    API_ENDPOINTS.DELETE_TASK_DISCUSSION + Encrption(id)
  );
};

const updateTask = (fields, selectedTaskId) => {
  var data = {
    taskDescription: fields.taskDescription,
    dueDate: moment(fields.dueDate).format("YYYY-MM-DD"),
    isHighPriorityTask: fields.isHighPriorityTask,
    id: selectedTaskId,
  };
  return customAxios.put(API_ENDPOINTS.UPDATE_TASK, data);
};

const insertDiscussion = (discussion, assignedToId) => {
  var data = {
    assignedToId: assignedToId,
    description: discussion,
  };
  return customAxios.post(API_ENDPOINTS.INSERT_DISCUSSION, data);
};

const getTaskDiscussionByAssignedId = (id) => {
  return customAxios.get(
    API_ENDPOINTS.GET_TASK_DISCUSSION_BY_ASSIGNED_ID + Encrption(id)
  );
};

const updateDiscussion = (
  description,
  selectedTaskId,
  selectedDiscussionId
) => {
  var data = {
    assignedToId: selectedTaskId,
    description: description,
    id: selectedDiscussionId,
  };
  return customAxios.put(API_ENDPOINTS.UPDATE_DISCUSSION, data);
};

const getDiscussionById = (id) => {
  return customAxios.get(
    API_ENDPOINTS.GET_TASK_DISCUSSION_BY_ID + Encrption(id)
  );
};

const updateTaskStatus = (taskObj) => {
  let taskArry = [];
  taskArry.push(taskObj.id);
  var data = {
    assignedTaskIds: taskArry,
    isCompleted: taskObj.isCompleted,
    isInProgress: taskObj.isInProgress,
  };
  return customAxios.put(API_ENDPOINTS.UPDATE_TASK_STATUS, data);
};

const getDateFormatted = (currentDate, dateforMatted) => {
  return customAxios.get(
    API_ENDPOINTS.GET_FORMATTED_DATE +
      "currentDate" +
      "=" +
      currentDate +
      "&" +
      "dateToFormat" +
      "=" +
      dateforMatted
  );
};

export const TaskService = {
  addTask,
  getTaskSearch,
  getTaskDetail,
  deleteTask,
  updateTask,
  insertDiscussion,
  getTaskDiscussionByAssignedId,
  deleteTaskDiscussion,
  updateDiscussion,
  getDiscussionById,
  updateTaskStatus,
  getDateFormatted,
};
